/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Edit_Profile_Image_LabelInputs */

const es_user_profile_edit_profile_image_label = /** @type {(inputs: User_Profile_Edit_Profile_Image_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen de perfil`)
};

const en_user_profile_edit_profile_image_label = /** @type {(inputs: User_Profile_Edit_Profile_Image_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile image`)
};

/**
* | output |
* | --- |
* | "Profile image" |
*
* @param {User_Profile_Edit_Profile_Image_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_edit_profile_image_label = /** @type {((inputs?: User_Profile_Edit_Profile_Image_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Edit_Profile_Image_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_edit_profile_image_label(inputs)
	return en_user_profile_edit_profile_image_label(inputs)
});
export { user_profile_edit_profile_image_label as "user.profile.edit.profile_image_label" }